module.exports = __webpack_public_path__ + "static/media/head.31f7cacf.svg";